import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routes'
import { createPinia } from 'pinia'
import CKEditor from '@ckeditor/ckeditor5-vue';
import './styles/bootstrap@5.2.0.min.css'
import './styles/css-style.css'
import './styles/helper.css'
import './styles/css-helper.css'
import './styles/css-style-text.css'
import './styles/custom-ckeditor.css'


createApp(App)
    .use(createPinia())
    .use(router)
    .use(CKEditor)
    .mount('#app')
